/*
* Created by Skeets 2017-12-04
* Recreated by Skeets 2020-01-25, added promptInput() and ShowAlert() to make it modal.js instead of confirm.js
* */

function showAlert(obj, title)
{
  if (typeof obj !== "object") {
    obj = {msg: obj};
  }
  if (typeof title !== "undefined" && title !== null && title.length > 0) {
    obj.title = title;
  }
  obj = modalJs.prepareObj(obj, {title: "Info", msg: "", noCancel: true, yes: "Ok"});
  modalJs.appendDialog(obj);
  modalJs.releaseBindings(obj);
  modalJs.elements.$modal.modal("show");
}

function onConfirm(obj)
{
  obj = modalJs.prepareObj(obj);

  if (typeof obj.skip !== "undefined" && obj.skip === true) {
    obj.yesCallback(obj.yesParams);
    obj.yesHiddenCallback(obj.yesParams);
    return true;
  }

  modalJs.appendDialog(obj);
  modalJs.bindings(obj);
  modalJs.elements.$modal.modal("show");
}

function promptInput(vars, obj)
{
  obj           = modalJs.prepareObj(obj, {msg: "", title: "Set value", yes: "Go"});
  var inputHtml = modalJs.prepareInputHtml(vars, obj.labelWidth);
  obj.msg += inputHtml;
  modalJs.appendDialog(obj);
  modalJs.bindings(obj);
  modalJs.elements.$modal.on('shown.bs.modal', function() {
    modalJs.elements.$modal.find("input:first").focus();
    modalJs.elements.$modal.off('shown.bs.modal');
  });
  modalJs.elements.$modal.modal("show");

}

var modalJs = {
  dialogAppended  : false,
  elements        : {
    $modal  : null,
    $dialog : null,
    $content: null,
    $header : null,
    $body   : null,
    $footer : null,
    $title  : null,
    $cancel : null,
    $ok     : null
  },
  appendDialog    : function(obj) {
    if (modalJs.dialogAppended) {
      modalJs.elements.$title.html(obj.title);
      modalJs.elements.$body.html(obj.msg);
      modalJs.elements.$cancel.html(obj.no);
      modalJs.elements.$ok.html(obj.yes);
      if (obj.noCancel) {
        modalJs.elements.$cancel.hide();
      }
      else {
        modalJs.elements.$cancel.show();
      }
      return true;
    }
    var elements      = {};
    elements.$form    = $("<form/>", {id: "modal-js-form"});
    elements.$modal   = $("<div/>", {
      class: "modal fade",
      role : "dialog",
      id   : "confirm-js-dialog"
    });
    elements.$dialog  = $("<div/>", {class: "modal-dialog", role: "document"});
    elements.$content = $("<div/>", {class: "modal-content"});
    elements.$header  = $("<div/>", {class: "modal-header"});
    elements.$body    = $("<div/>", {class: "modal-body"});
    elements.$footer  = $("<div/>", {class: "modal-footer"});
    elements.$title   = $("<h5/>", {class: "modal-title"});
    elements.$cancel  = $("<button/>", {type: "button", class: "btn btn-secondary", "data-dismiss": "modal"});
    elements.$ok      = $("<button/>", {type: "submit", class: "btn btn-primary"});

    elements.$title.html(obj.title);
    elements.$body.html(obj.msg);
    elements.$cancel.html(obj.no);
    elements.$ok.html(obj.yes);

    elements.$footer.append([elements.$cancel, elements.$ok]);
    elements.$header.append(elements.$title);
    elements.$content.append([elements.$header, elements.$body, elements.$footer]);
    elements.$dialog.append(elements.$content);
    elements.$modal.append(elements.$dialog);
    elements.$form.append(elements.$modal);

    if (obj.noCancel) {
      elements.$cancel.hide();
    }
    else {
      elements.$cancel.show();
    }

    modalJs.elements = elements;

    $("body").append(elements.$form);
    modalJs.dialogAppended = true;
  },
  setDefaults     : function(obj, overrideDefaults) {
    var defaults = {
      title            : "Are you sure?",
      msg              : "Are you sure?",
      yes              : "Yes",
      no               : "Cancel",
      onHidden         : false,
      yesCallback      : function() {
      },
      yesHiddenCallback: function() {
      },
      yesParams        : [],
      yesType          : "success",
      noCallback       : function() {
      },
      noHiddenCallback : function() {
      },
      noParams         : [],
      noCancel         : false

    };

    for (var overrideProperty in overrideDefaults) {
      if (overrideDefaults.hasOwnProperty(overrideProperty)) {
        if (!obj.hasOwnProperty(overrideProperty)) {
          obj[overrideProperty] = overrideDefaults[overrideProperty];
        }
      }
    }
    for (var property in defaults) {
      if (defaults.hasOwnProperty(property)) {
        if (!obj.hasOwnProperty(property)) {
          obj[property] = defaults[property];
        }
      }
    }

    return obj;
  },
  setAliases      : function(obj) {
    var aliases = {msg: ["body"], yesCallback: ["callback"], yes: ["go"], no: ["cancel"]};

    for (var aliasedField in aliases) {
      if (aliases.hasOwnProperty(aliasedField)) {
        aliases[aliasedField].forEach(function(alias) {
          if (obj.hasOwnProperty(alias)) {
            obj[aliasedField] = obj[alias];
          }
        });
      }
    }
    return obj;
  },
  releaseBindings : function() {
    modalJs.elements.$form.off().on("submit", function(e) {
      e.preventDefault();
      modalJs.elements.$modal.modal("hide");
    });
    modalJs.elements.$cancel.off();
    modalJs.elements.$modal.off();
  },
  bindings        : function(obj) {
    var $modal = modalJs.elements.$modal;
    modalJs.elements.$ok.attr("class", "btn btn-" + obj.yesType);
    modalJs.elements.$form.off().on("submit", function(e) {
      e.preventDefault();
      var data = modalJs.arrayToObject($(this).serializeArray());
      for (var attrName in obj.yesParams) {
        if (obj.yesParams.hasOwnProperty(attrName)) {
          data[attrName] = obj.yesParams[attrName];
        }
      }

      if (obj.onHidden) {
        $modal.on('hidden.bs.modal', function() {
          obj.yesCallback(data);
          $modal.off('hidden.bs.modal');
        });
      }
      else {
        obj.yesCallback(data);
      }
      $modal.on('hidden.bs.modal', function() {
        obj.yesHiddenCallback(window, data);
        $modal.off('hidden.bs.modal');
      });
      $modal.modal("hide");
    });

    modalJs.elements.$cancel.off().on("click", function() {
      if (obj.onHidden) {
        $modal.on('hidden.bs.modal', function(e) {
          obj.noCallback(obj.noParams);
          $modal.off('hidden.bs.modal');
        });
      }
      else {
        obj.noCallback(obj.noParams);
      }
      $modal.on('hidden.bs.modal', function(e) {
        obj.noHiddenCallback(window, obj.noParams);
        $modal.off('hidden.bs.modal');
      });
      $modal.modal("hide");
    });
  },
  inputBuilders   : {
    text    : function(options, name, id, labelDivAttr) {
      var output = "";
      output += "<div class='row mb-3'>";
      output += "<div class='col-auto d-flex align-items-center'" + labelDivAttr + ">";
      output += "<label class='mb-0' for='" + id + "'>" + options.label + "</label>";
      output += "</div>";
      output += "<div class='col'>";
      output +=
        "<input " +
        options.attr +
        " type='" +
        options.inputType +
        "' id='" +
        id +
        "' class='form-control " +
        options.class +
        "' name='" +
        name +
        "'>";
      output += "</div>";
      output += "</div>";
      return output;
    },
    textarea: function(options, name, id) {
      var output = "";
      output += "<div class='row'>";
      output += "<div class='col' >";
      output += "<label for='" + id + "'>" + options.label + "</label>";
      output += "</div>";
      output += "</div>";
      output += "<div class='row mb-3'>";
      output += "<div class='col'>";
      output += "<textarea " + options.attr + " id='" + id + "' class='form-control " + options.class + "' name='" + name + "'></textarea>";
      output += "</div>";
      output += "</div>";
      return output;
    },
    select  : function(options, name, id, labelDivAttr) {
      var output = "";
      output += "<div class='row mb-3'>";
      output += "<div class='col-auto d-flex align-items-center'" + labelDivAttr + ">";
      output += "<label class='mb-0' for='" + id + "'>" + options.label + "</label>";
      output += "</div>";
      output += "<div class='col'>";
      output +=
        "<select " + options.attr + " id='" + id + "' class='form-control " + options.class + "' name='" + name + "'>";
      for (var value in options.selectOptions) {
        if (options.selectOptions.hasOwnProperty(value)) {
          output += "<option value='" + value + "'>" + options.selectOptions[value] + "</option>";
        }
      }
      output += "</select>";
      output += "</div>";
      output += "</div>";
      return output;
    }
  },
  prepareInputHtml: function(vars, labelWidth) {
    if (typeof vars !== "object") {
      var tempVar   = vars;
      vars          = {};
      vars[tempVar] = tempVar;
    }
    var labelDivAttr;
    if (typeof labelWidth !== "undefined" && labelWidth !== null) {
      labelDivAttr = " style='width: " + labelWidth + "px;' ";
    }
    var inputs  = "";
    var countId = 0;
    for (var prop in vars) {
      if (vars.hasOwnProperty(prop)) {
        if (typeof vars[prop] !== "object") {
          vars[prop] = {"label": vars[prop]};
        }
        if (typeof vars[prop].attr === "undefined" || vars[prop].attr === null) {
          vars[prop].attr = "";
        }
        if (typeof vars[prop].class === "undefined" || vars[prop].class === null) {
          vars[prop].class = "";
        }
        var id = "prompt-js-input-id-" + countId;
        if (typeof vars[prop].inputType === "undefined") {
          vars[prop].inputType = "text";
        }
        switch (vars[prop].inputType) {
          case "text":
          default:
            inputs += modalJs.inputBuilders.text(vars[prop], prop, id, labelDivAttr);
            break;
          case "textarea":
            inputs += modalJs.inputBuilders.textarea(vars[prop], prop, id);
            break;
          case "select":
            inputs += modalJs.inputBuilders.select(vars[prop], prop, id, labelDivAttr);
            break;
        }
        countId++;
      }
    }
    return inputs;
  },
  prepareObj      : function(obj, overrideDefaults) {
    if (typeof obj !== "object") {
      obj = {};
    }

    obj = modalJs.setDefaults(obj, overrideDefaults);
    obj = modalJs.setAliases(obj);
    return obj;
  },
  arrayToObject   : function(array) {
    var output = {};
    array.forEach(function(element) {
      if (typeof output[element.name] === "undefined") {
        output[element.name] = element.value;
      }
      else {
        if (typeof output[element.name] === "object") {
          output[element.name].push(element.value);
        }
        else {
          output[element.name] = [output[element.name], element.value];
        }

      }

    });

    return output;
  }


};

